// extracted by mini-css-extract-plugin
export default {"search_box":"index_search_box_KngnO","searchInput":"index_searchInput_jbH4h","searchBtn":"index_searchBtn_T2N6O"};